import { useState, useEffect, useRef } from "react";

// ── Brand tokens (shared across all pages) ────────────────────────────────────
const C = {
  darkGreen:  "#052C0C",
  limeGreen:  "#9ACA44",
  oliveGreen: "#819951",
  cream:      "#1D2C1E",
  white:      "#102216",
  darkBg:     "#FFFFFF",
  cardBg:     "#F7FAF4",
  border:     "rgba(5,44,12,0.16)",
  textFaint:  "rgba(16,34,22,0.72)",
  textMid:    "rgba(16,34,22,0.86)",
};

const NAV_LINKS = ["#/About", "#/Contact", "#/FAQ"];
// const LOGO_SRC = "/wp-content/themes/satp/assets/logo.png"; // ← update this path
const LOGO_SRC = "https://syntropypro.com/wp-content/uploads/2026/04/SATFPM-LOGO-1.png";

// ── Shared header (same shrinking behavior as landing page) ───────────────────
function Header({ scrolled, isMobile, menuOpen, setMenuOpen }) {
  return (
    // <header style={{
    //   position: "fixed", top: 0, left: 0, right: 0, zIndex: 999,
    //   display: "flex", flexDirection: isMobile ? "column" : "row",
    //   alignItems: isMobile ? "flex-start" : "center", justifyContent: "space-between",
    //   gap: isMobile ? 10 : 0,
    //   padding: scrolled ? (isMobile ? "10px 16px" : "10px 52px") : (isMobile ? "14px 16px" : "22px 52px"),
    //   background: "rgba(5,44,12,0.96)",
    //   backdropFilter: "blur(14px)",
    //   borderBottom: `1px solid ${C.border}`,
    //   transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
    // }}>
    //   <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
    //     {/* <img src={LOGO_SRC} alt="SATP" style={{ height: scrolled ? 36 : 50, transition: "height 0.4s ease", filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))" }} /> */}
    //     <img src={LOGO_SRC} alt="SAT" style={{ height: scrolled ? 36 : 50, transition: "height 0.4s ease", filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))" }} />
    //     <div>
    //       <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1, transition: "font-size 0.4s ease" }}>SYNTROPY</div>
    //       <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase", transition: "font-size 0.4s ease" }}>ALLIANCE TRADE</div>
    //     </div>
    //   </a>
    //   <nav style={{ display: "flex", gap: isMobile ? 14 : 36, alignItems: "center", flexWrap: "wrap" }}>
    //     {NAV_LINKS.map((link) => {
    //       const label = link.replace(/#\//g, "");
    //       const isActive = label.toLowerCase() === "about";
    //       return (
    //         <a key={link} href={`/${link.toLowerCase()}`}
    //           style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: isActive ? C.limeGreen : "rgba(230,203,161,0.7)", fontWeight: isActive ? 600 : 500, textDecoration: "none", transition: "color 0.2s" }}
    //           onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
    //           onMouseLeave={(e) => (e.target.style.color = isActive ? C.limeGreen : "rgba(230,203,161,0.7)")}>
    //           {label}
    //         </a>
    //       );
    //     })}
    //     <a key="affiliate-dashboard-link" href="affiliate-dashboard"
    //         style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
    //         onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
    //         onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
    //         Affiliate Dashboard
    //     </a>
    //     <a href="/shop" style={{ padding: "10px 24px", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, color: C.darkGreen, borderRadius: 3, fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", textDecoration: "none", display: "inline-block" }}>
    //       Shop Now
    //     </a>
    //   </nav>
    // </header>
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 999,
      background: "rgba(5,44,12,0.96)",
      backdropFilter: "blur(14px)",
      borderBottom: `1px solid ${C.borderFaint}`,
      transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
    }}>
      {/* <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
        <img
          src={LOGO_SRC}
          alt="SAT"
          style={{
            height: scrolled ? 36 : 50,
            transition: "height 0.35s ease",
            filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))",
          }}
        />
        <div>
          <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1 }}>
            SYNTROPY
          </div>
          <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase" }}>
            ALLIANCE TRADE
          </div>
        </div>
      </a> */}

      {/* Top bar: logo + burger (mobile) or logo + nav (desktop) */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: scrolled ? (isMobile ? "10px 16px" : "10px 52px") : (isMobile ? "14px 16px" : "22px 52px"),
          transition: "padding 0.4s cubic-bezier(0.4,0,0.2,1)",
        }}>
          {/* Logo */}
          <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
            <img
              src={LOGO_SRC}
              alt="SAT"
              style={{
                height: scrolled ? 36 : 50,
                transition: "height 0.35s ease",
                filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))",
              }}
            />
            <div>
              <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1 }}>
                SYNTROPY
              </div>
              <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase" }}>
                ALLIANCE TRADE
              </div>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="desktop-nav" style={{ display: "flex", gap: 36, alignItems: "center" }}>
            {NAV_LINKS.map((link) => (
              <a key={link} href={`${link.toLowerCase()}`}
                style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a key="affiliate-dashboard-link" href="affiliate-dashboard"
              style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
              onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
              Affiliate Dashboard
            </a>
            <a href="/shop" style={{ padding: "10px 24px", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, color: C.darkGreen, borderRadius: 3, fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", textDecoration: "none", display: "inline-block" }}>
              Shop Now
            </a>
          </nav>

          {/* Burger Button (mobile only) */}
          <button
            className={`burger-btn${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobile && menuOpen && (
          <nav style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            borderTop: `1px solid rgba(154,202,68,0.12)`,
            animation: "slideDown 0.22s ease",
          }}>
            {NAV_LINKS.map((link) => (
              <a
                key={link}
                href={`${link.toLowerCase()}`}
                onClick={() => setMenuOpen(false)}
                style={{
                  fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                  color: "rgba(230,203,161,0.75)", fontWeight: 500,
                  padding: "14px 20px",
                  borderBottom: `1px solid rgba(154,202,68,0.08)`,
                  transition: "color 0.2s, background 0.2s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
              >
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a
              href="affiliate-dashboard"
              onClick={() => setMenuOpen(false)}
              style={{
                fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                color: "rgba(230,203,161,0.75)", fontWeight: 500,
                padding: "14px 20px",
                borderBottom: `1px solid rgba(154,202,68,0.08)`,
                transition: "color 0.2s, background 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
            >
              Affiliate Dashboard
            </a>
            <div style={{ padding: "14px 20px" }}>
              <a
                href="/shop"
                onClick={() => setMenuOpen(false)}
                style={{
                  display: "block", textAlign: "center",
                  padding: "12px 24px",
                  background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`,
                  color: C.darkGreen, borderRadius: 3,
                  fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase",
                }}
              >
                Shop Now
              </a>
            </div>
          </nav>
        )}
    </header>
  );
}

// ── Data ──────────────────────────────────────────────────────────────────────
const TIMELINE = [
  // { year: "2025", title: "Founded",        desc: "Syntropy Alliance Trade was born from a shared belief: that nature already has the answers — science just needs to listen." },
  { year: "2025", title: "Founded",        desc: "Syntropy Alliance Trade was born." },
  // { year: "2015", title: "First Formula",  desc: "Our flagship immunity blend launched, combining 12 adaptogenic herbs with clinically validated dosages. It sold out in 48 hours." },
  // { year: "2018", title: "Research Lab",   desc: "We opened our own in-house R&D facility, partnering with independent biochemists to validate every ingredient we source." },
  // { year: "2021", title: "50,000 Members", desc: "Our wellness community crossed 50,000 members — proof that people were hungry for products they could actually trust." },
  // { year: "2024", title: "Global Reach",   desc: "SATP products now ship to 28 countries, bringing nature's intelligence to communities across Asia, Europe, and the Americas." },
  { year: "2026", title: "Today",          desc: "Thousands of lives transformed and counting. We remain committed to purity, transparency, and the science of synergy." },
];

const VALUES = [
  { icon: "🌱", title: "Sustainability",     desc: "We champion eco-conscious solutions and health-driven products supported by efficient, tech-enabled practices.​" },
  { icon: "🤝", title: "Collaboration",    desc: "We cultivate a connected digital community where leaders, resellers, and partners accelerate growth through shared data, insights, and tools.​" },
  { icon: "🔬", title: "Innovation",   desc: "We embrace emerging technologies, automation, and digital intelligence to expand our reach and strengthen our value chain.​" },
  { icon: "♻️", title: "Integrity", desc: "We hold transparency and accountability at the core of all digital and physical transactions.​" },
  { icon: "🧬", title: "Empowerment",      desc: "We enable individuals and communities to thrive through accessible digital systems and scalable entrepreneurial opportunities.​" },
  { icon: "❤️", title: "Purpose-Driven Passion​",    desc: "We bring energy, creativity, and vision into transforming every product and every partnership into meaningful change.​" },
];

const TEAM = [
  { name: "Dr. Elena Vasquez",  role: "Co-Founder & Chief Science Officer", initials: "EV", bio: "PhD in Phytochemistry from UST. 20 years developing botanical medicines with WHO-affiliated research institutions." },
  // { name: "Marcus Tanaka",      role: "Co-Founder & CEO",                   initials: "MT", bio: "Former sustainable supply chain director at a Fortune 500. Built SATP's ethical sourcing network from the ground up." },
  { name: "Marcus Tanaka",      role: "Co-Founder & CEO",                   initials: "MT", bio: "Former sustainable supply chain director at a Fortune 500. Built SAT's ethical sourcing network from the ground up." },
  { name: "Dr. Aisha Ramos",    role: "Head of Formulation",                initials: "AR", bio: "Registered pharmacist and naturopath with a passion for bridging conventional and integrative medicine." },
  { name: "Felix Okonkwo",      role: "Head of Community & Partnerships",   initials: "FO", bio: "Social entrepreneur who led health equity programs across Southeast Asia before joining SATP." },
];

// ── Main component ────────────────────────────────────────────────────────────
export default function AboutPage() {
  const [scrolled, setScrolled]           = useState(false);
  const [menuOpen, setMenuOpen]                           = useState(false);
  const [visibleSections, setVisible]     = useState({});
  const [viewportWidth, setViewportWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  const sectionRefs = useRef({});
  const isMobile = viewportWidth <= 768;
  const isTablet = viewportWidth <= 1024;

  useEffect(() => {
    window.scrollTo(0, 0);

    const fn = () => setScrolled(window.scrollY > 70);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const onResize = () => {
      setViewportWidth(window.innerWidth);
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) setVisible((p) => ({ ...p, [e.target.dataset.section]: true }));
      }),
      { threshold: 0.1 }
    );
    Object.values(sectionRefs.current).forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const setRef  = (k) => (el) => { sectionRefs.current[k] = el; };
  const visible = (k) => visibleSections[k];

  const sectionTag  = { fontSize: 11, letterSpacing: "0.28em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 14 };
  const sectionHead = { fontSize: "clamp(30px,4vw,52px)", fontWeight: 300, lineHeight: 1.18, color: C.white, marginBottom: 16, fontFamily: "'Playfair Display', serif" };

  return (
    <div style={{ fontFamily: "'Outfit', 'Segoe UI', sans-serif", background: C.darkBg, color: C.cream, minHeight: "100vh", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes fadeUp  { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
        @keyframes fadeIn  { from{opacity:0} to{opacity:1} }
        @keyframes lineGrow{ from{height:0} to{height:100%} }
        body { background:${C.darkBg}; }
        ::-webkit-scrollbar{width:4px}
        ::-webkit-scrollbar-thumb{background:rgba(154,202,68,.3);border-radius:2px}
        a{text-decoration:none}
        .blob{position:absolute;border-radius:50%;filter:blur(90px);pointer-events:none}

        /* Burger button */
        .burger-btn {
          display: none;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px;
          z-index: 1001;
        }
        .burger-btn span {
          display: block;
          width: 22px;
          height: 2px;
          background: rgba(230,203,161,0.85);
          border-radius: 2px;
          transition: transform 0.3s ease, opacity 0.3s ease;
        }
        .burger-btn.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        .burger-btn.open span:nth-child(2) { opacity: 0; }
        .burger-btn.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

        @media (max-width: 768px) {
          .burger-btn { display: flex; }
          .desktop-nav { display: none !important; }
        }
      `}</style>

      <Header scrolled={scrolled} isMobile={isMobile} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      {/* ══════════════════════════════════════ HERO ── */}
      <section style={{ minHeight: "62vh", display: "flex", alignItems: "center", padding: isMobile ? "170px 20px 54px" : "140px 60px 90px", position: "relative", overflow: "hidden" }}>
        {/* <div className="blob" style={{ width: 700, height: 500, background: C.darkGreen, top: "-20%", right: "-15%", opacity: 0.5 }} /> */}
        {/* <div className="blob" style={{ width: 400, height: 400, background: C.limeGreen, bottom: "-20%", left: "-5%", opacity: 0.06 }} /> */}

        {/* Vertical rule */}
        <div style={{ display: isMobile ? "none" : "block", position: "absolute", left: 60, top: 0, bottom: 0, width: 1, background: `linear-gradient(to bottom,transparent,${C.limeGreen}44,transparent)` }} />

        <div style={{ position: "relative", maxWidth: 1180, margin: "0 auto", width: "100%" }}>
          <div style={{ display: "grid", gridTemplateColumns: isTablet ? "1fr" : "1fr 1fr", gap: isTablet ? 30 : 80, alignItems: "center" }}>
            <div>
              <div style={{ ...sectionTag, animation: "fadeUp 0.7s ease both" }}>Our Story</div>
              <h1 style={{ ...sectionHead, marginBottom: 24, animation: "fadeUp 0.8s 0.1s ease both" }}>
                {/* Born from the Belief That <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Nature Has the Answers</span> */}
                <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Rooted in Purpose. Growing in Unity. Trading for Good. Powered by Digital Innovation.​</span>
              </h1>
              <p style={{ fontSize: 16, lineHeight: 1.8, color: C.textFaint, marginBottom: 20, animation: "fadeUp 0.9s 0.2s ease both" }}>
                Syntropy Alliance Trade was founded in 2025.
              </p>
              {/* <p style={{ fontSize: 16, lineHeight: 1.8, color: C.textFaint, animation: "fadeUp 0.9s 0.28s ease both" }}>
                We chose a different path — one guided by the principle of <em style={{ color: C.cream }}>syntropy</em>: the force that creates order, coherence, and life. Every product we make is a deliberate expression of that principle.
              </p> */}
            </div>

            {/* Logo feature */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", animation: "fadeIn 1.2s 0.3s ease both" }}>
              <div style={{ position: "relative" }}>
                <div style={{ width: isMobile ? 240 : 320, height: isMobile ? 240 : 320, borderRadius: "50%", background: `radial-gradient(circle,rgba(154,202,68,0.1) 0%,transparent 70%)`, display: "flex", alignItems: "center", justifyContent: "center", border: `1px solid ${C.border}` }}>
                  {/* <img src={LOGO_SRC} alt="SATP" style={{ width: 220, height: "auto", filter: "drop-shadow(0 8px 40px rgba(154,202,68,0.3))" }} /> */}
                  <img src={LOGO_SRC} alt="SAT" style={{ width: 220, height: "auto", filter: "drop-shadow(0 8px 40px rgba(154,202,68,0.3))" }} />
                </div>
                {/* Orbit ring */}
                <div style={{ position: "absolute", inset: -20, borderRadius: "50%", border: `1px dashed rgba(154,202,68,0.2)`, animation: "spin 24s linear infinite" }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════ MISSION STATEMENT ── */}
      <div style={{ background: "linear-gradient(135deg,#FFFFFF,#EDF6E3)", padding: isMobile ? "40px 20px" : "56px 60px", borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: 900, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.28em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 20 }}>Mission Statement</div>
          <blockquote style={{ fontSize: "clamp(20px,3vw,32px)", fontWeight: 300, lineHeight: 1.55, color: C.white, fontFamily: "'Playfair Display', serif", fontStyle: "italic" }}>
            "To promote natural wellness and economic empowerment by connecting people, products, and purpose through smart digital ecosystems, sustainable trade technologies, and a collaborative alliance network that drives modern entrepreneurship.​"
          </blockquote>
          <div style={{ width: 48, height: 2, background: `linear-gradient(to right,${C.limeGreen},${C.oliveGreen})`, margin: "28px auto 0", borderRadius: 1 }} />
        </div>
        <br />
        <div style={{ maxWidth: 900, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.28em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 20 }}>Vision Statement</div>
          <blockquote style={{ fontSize: "clamp(20px,3vw,32px)", fontWeight: 300, lineHeight: 1.55, color: C.white, fontFamily: "'Playfair Display', serif", fontStyle: "italic" }}>
            "To become a global force in sustainable food marketing and ethical trade by leveraging advanced digital platforms, intelligent systems, and innovation-driven strategies that empower communities and accelerate unified growth.​"
          </blockquote>
          <div style={{ width: 48, height: 2, background: `linear-gradient(to right,${C.limeGreen},${C.oliveGreen})`, margin: "28px auto 0", borderRadius: 1 }} />
        </div>
      </div>

      {/* ══════════════════════════════════════ VALUES ── */}
      <section style={{ padding: isMobile ? "70px 20px" : "100px 60px", maxWidth: 1240, margin: "0 auto" }}
        ref={setRef("values")} data-section="values">
        <div style={{ textAlign: "center", marginBottom: 64 }}>
          <div style={sectionTag}>What We Stand For</div>
          <h2 style={{ ...sectionHead, display: "inline-block" }}>Our Core <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Values</span></h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "repeat(3,1fr)", gap: 24 }}>
          {VALUES.map((v, i) => (
            <div key={v.title} style={{
              padding: "36px 30px", border: `1px solid ${C.border}`, borderRadius: 6,
              background: C.cardBg,
              opacity: visible("values") ? 1 : 0,
              transform: visible("values") ? "translateY(0)" : "translateY(28px)",
              transition: `opacity 0.55s ${i * 0.08}s ease, transform 0.55s ${i * 0.08}s ease`,
            }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(154,202,68,0.4)"; e.currentTarget.style.background = "rgba(154,202,68,0.04)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.background = C.cardBg; }}>
              {/* <div style={{ fontSize: 32, marginBottom: 16 }}>{v.icon}</div> */}
              <div style={{ fontSize: 17, fontWeight: 600, color: C.white, marginBottom: 10 }}>{v.title}</div>
              <div style={{ fontSize: 14, lineHeight: 1.75, color: C.textFaint }}>{v.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ══════════════════════════════════════ TIMELINE ── */}
      <section style={{ padding: isMobile ? "70px 20px" : "80px 60px 100px", background: "linear-gradient(180deg,#FFFFFF 0%,rgba(154,202,68,0.10) 100%)", borderTop: `1px solid ${C.border}` }}
        ref={setRef("timeline")} data-section="timeline">
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 72 }}>
            <div style={sectionTag}>Our Journey</div>
            {/* <h2 style={{ ...sectionHead }}>A Decade of <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Dedication</span></h2> */}
          </div>

          <div style={{ position: "relative" }}>
            {/* Center line */}
            <div style={{ display: isMobile ? "none" : "block", position: "absolute", left: "50%", top: 0, bottom: 0, width: 1, background: `linear-gradient(to bottom,transparent,${C.limeGreen}50,transparent)`, transform: "translateX(-50%)" }} />

            {TIMELINE.map((item, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div key={item.year} style={{
                  display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: 0, marginBottom: isMobile ? 30 : 48,
                  opacity: visible("timeline") ? 1 : 0,
                  transform: visible("timeline") ? "translateY(0)" : "translateY(20px)",
                  transition: `opacity 0.5s ${i * 0.1}s ease, transform 0.5s ${i * 0.1}s ease`,
                }}>
                  {/* Left content */}
                  <div style={{ paddingRight: isMobile ? 0 : 48, textAlign: isMobile ? "left" : "right", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    {(isMobile || isLeft) && (
                      <>
                        <div style={{ fontSize: 28, fontWeight: 700, color: C.limeGreen, fontFamily: "'Playfair Display', serif", lineHeight: 1 }}>{item.year}</div>
                        <div style={{ fontSize: 16, fontWeight: 600, color: C.white, margin: "6px 0 8px" }}>{item.title}</div>
                        <div style={{ fontSize: 14, lineHeight: 1.7, color: C.textFaint }}>{item.desc}</div>
                      </>
                    )}
                  </div>

                  {/* Center dot */}
                  <div style={{ position: "relative", paddingLeft: isMobile ? 0 : 48, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <div style={{ display: isMobile ? "none" : "block", position: "absolute", left: -7, top: "50%", transform: "translateY(-50%)", width: 14, height: 14, borderRadius: "50%", background: C.limeGreen, border: `3px solid ${C.darkBg}`, boxShadow: `0 0 0 2px ${C.limeGreen}` }} />
                    {!isMobile && !isLeft && (
                      <>
                        <div style={{ fontSize: 28, fontWeight: 700, color: C.limeGreen, fontFamily: "'Playfair Display', serif", lineHeight: 1 }}>{item.year}</div>
                        <div style={{ fontSize: 16, fontWeight: 600, color: C.white, margin: "6px 0 8px" }}>{item.title}</div>
                        <div style={{ fontSize: 14, lineHeight: 1.7, color: C.textFaint }}>{item.desc}</div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════ TEAM ── */}
      {/* <section style={{ padding: isMobile ? "70px 20px" : "100px 60px", maxWidth: 1240, margin: "0 auto" }}
        ref={setRef("team")} data-section="team">
        <div style={{ textAlign: "center", marginBottom: 64 }}>
          <div style={sectionTag}>The People Behind SAT</div>
          <h2 style={{ ...sectionHead }}>Meet Our <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Team</span></h2>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 24 }}>
          {TEAM.map((member, i) => (
            <div key={member.name} style={{
              padding: "36px 24px 32px", textAlign: "center",
              border: `1px solid ${C.border}`, borderRadius: 6, background: C.cardBg,
              opacity: visible("team") ? 1 : 0,
              transform: visible("team") ? "translateY(0)" : "translateY(28px)",
              transition: `opacity 0.55s ${i * 0.1}s ease, transform 0.55s ${i * 0.1}s ease`,
            }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(154,202,68,0.4)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = C.border; }}>
              <div style={{ width: 72, height: 72, borderRadius: "50%", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 700, color: C.darkGreen, margin: "0 auto 20px" }}>
                {member.initials}
              </div>
              <div style={{ fontSize: 15, fontWeight: 600, color: C.white, marginBottom: 4 }}>{member.name}</div>
              <div style={{ fontSize: 11, letterSpacing: "0.1em", color: C.limeGreen, textTransform: "uppercase", marginBottom: 14 }}>{member.role}</div>
              <div style={{ fontSize: 13, lineHeight: 1.7, color: C.textFaint }}>{member.bio}</div>
            </div>
          ))}
        </div>
      </section> */}

      {/* ══════════════════════════════════════ CTA ── */}
      <section style={{ padding: isMobile ? "80px 20px" : "100px 60px", textAlign: "center", background: "linear-gradient(160deg,#FFFFFF 0%,#EDF6E3 100%)", borderTop: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: 620, margin: "0 auto" }}>
          <div style={sectionTag}>Ready to Experience Syntropy?</div>
          <h2 style={{ ...sectionHead, fontSize: "clamp(28px,3.5vw,46px)" }}>
            Join a Community That <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Trusts the Science</span>
          </h2>
          <p style={{ fontSize: 16, color: C.textFaint, lineHeight: 1.75, marginBottom: 40 }}>
            Every product is a reflection of who we are — transparent, intentional, and deeply committed to your wellbeing.
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
            <a href="/shop" style={{ padding: "14px 40px", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, color: C.darkGreen, borderRadius: 3, fontSize: 13, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
              Shop Products
            </a>
            <a href="#/contact" style={{ padding: "14px 36px", border: `1px solid rgba(230,203,161,0.35)`, color: C.cream, borderRadius: 3, fontSize: 13, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase" }}>
              Get in Touch
            </a>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════ FOOTER */}
      <footer style={{ background: C.darkGreen, borderTop: `1px solid rgba(154,202,68,0.15)` }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: isMobile ? "36px 20px 24px" : "52px 60px 36px", display: "grid", gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2,1fr)" : "2fr 1fr 1fr 1fr", gap: isMobile ? 30 : 48 }}>
          {/* Brand col */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <img src={LOGO_SRC} alt="SATP" style={{ height: 44, width: "auto" }} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#FFFFFF", letterSpacing: "0.06em" }}>SYNTROPY</div>
                <div style={{ fontSize: 8, letterSpacing: "0.22em", color: C.limeGreen }}>ALLIANCE TRADE</div>
              </div>
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.7, color: "rgba(230,203,161,0.5)", maxWidth: 240 }}>
              {/* Science-backed wellness products crafted from nature's finest ingredients. */}
              Rooted in Purpose. Growing in Unity. Trading for Good. Powered by Digital Innovation.​
            </p>
          </div>

          {/* Links */}
          {[
            // { title: "Products",  links: ["Health Supplements", "Herbal Blends", "Bundles", "New Arrivals"] },
            // { title: "Company",   links: ["About Us", "Our Science", "Sustainability", "Careers"] },
            { title: "Company",   links: ["About Us"] },
            { title: "Support",   links: ["Contact", "FAQ"] },
          ].map((col) => (
            <div key={col.title}>
              <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 18, fontWeight: 600 }}>{col.title}</div>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
                {
                  col.title === "Company"
                    ? <li key="company__about-us">
                        <a href="#/about" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          About Us
                        </a>
                      </li>
                    : ""
                }

                {
                  col.title === "Support"
                    ? <li key="support__contact">
                        <a href="#/contact" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          Contact
                        </a>
                      </li>
                    : ""
                }
                {
                  col.title === "Support"
                    ? <li key="support__faq">
                        <a href="#/faq" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                          onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                          onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                          FAQ
                        </a>
                      </li>
                    : ""
                }

                {/* BACKUP */}
                {/* {col.links.map((l) => (
                  <li key={l}>
                    <a href="#" style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                      onMouseEnter={(e) => (e.target.style.color = C.cream)}
                      onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}>
                      {l}
                    </a>
                  </li>
                ))} */}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ borderTop: `1px solid rgba(154,202,68,0.1)`, padding: isMobile ? "16px 20px" : "20px 60px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <span style={{ fontSize: 12, color: "rgba(230,203,161,0.3)" }}>© 2026 Syntropy Alliance Trade. All rights reserved.</span>
          <div style={{ display: "flex", gap: 24 }}>
            {["Privacy Policy", "Terms of Use", "Refund Policy"].map((l) => (
              <a key={l} href="#" style={{ fontSize: 11, color: "rgba(230,203,161,0.3)", letterSpacing: "0.08em", transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.3)")}>
                {l}
              </a>
            ))}
          </div>
        </div>
      </footer>

      <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
    </div>
  );
}
